import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";

import { useCategoryLookups, useCategory, useSaveCategory } from "./useCategory";

export function useCategoryForm({ option, filters, elementId, baseObject, onClose }) {
	const isOpen = option === "crear" || option === "editar";
	const isEditMode = option === "editar";
	const modalTitle = useMemo(() => (isEditMode ? "Editar Categoría" : "Crear Categoría"), [isEditMode]);

	const { mutate: saveCategory, isLoading: isLoadingSave } = useSaveCategory();
	const { data: lookups, isLoading: isLoadingLookups } = useCategoryLookups(isOpen);

	const canLoadDetail = isEditMode && !!elementId && !!lookups && !isLoadingLookups;
	const { data: element, isLoading: isLoadingElement, isFetching: isFetchingElement } = useCategory(filters, elementId, canLoadDetail);

	const [formState, setFormState] = useState({ ...baseObject });
	const [formErrors, setFormErrors] = useState({});

	useEffect(() => {
		if (isEditMode && element) {
			setFormState((prev) => ({
				...prev,
				...element,
			}));
		}
	}, [isEditMode, element]);

	const validateForm = (state) => {
		const next = {};
		if (!state.name) next.name = "Requerido";
		return next;
	};

	const buildPayload = (state) => {
		return {
			form: {
				id: isEditMode ? state.id : undefined,
				slug: isEditMode ? elementId : undefined,
				name: state.name,
				description: state.description,
				estates_ids: state.estates_ids || [],
				estates_parents_ids: state.estates_parents_ids || [],
			},
			filters: filters,
		};
	};

	const handleSubmit = async (event) => {
		event.preventDefault();

		const nextErrors = validateForm(formState);
		setFormErrors(nextErrors);
		if (Object.keys(nextErrors).length) return;

		const payload = buildPayload(formState);

		saveCategory(payload, {
			onSuccess: () => {
				toast.success(isEditMode ? "Categoría actualizada" : "Categoría creada");
				onClose();
			},
			onError: (error) => {
				toast.error(<div style={{ whiteSpace: "pre-line" }}>{error?.response?.data?.message || "Error al guardar Categoría"}</div>);
			},
		});
	};

	return {
		isOpen,
		isEditMode,
		modalTitle,
		isLoadingLookups,
		isLoadingSave,
		isLoadingElement,
		isFetchingElement,
		lookups,

		formState,
		setFormState,
		formErrors,
		setFormErrors,

		handleSubmit,
	};
}
